import { FC, useContext } from 'react'
import { PositionRange } from '../../types'
import { ChannelsSelection } from './ChannelsSelection'
import { ChannelsSelectionHandle } from './ChannelsSelectionHandle'
import './ChannelsEditableSelection.scss'
import { CutterContext } from '../contexts/CutterContext'
import { InternalContext } from '../contexts/InternalContext'
import { useVisiblePixelSize } from '../hooks/useVisiblePixelSize'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'

interface Props {
  internalSelection: PositionRange
}

export const ChannelsEditableSelection: FC<Props> = ({ internalSelection }) => {
  const {
    setSelection,
    audio: { length },
    audioBuffer: { sampleRate },
  } = useContext(CutterContext)
  const {
    setInternalSelection,
    autoplayEnabled,
    audioPlayer: { play },
  } = useContext(InternalContext)
  const updateSelection = () => {
    logger.log(LogActionType.ChannelsSelectionHandleChange, {
      selection: internalSelection,
    })

    setSelection(internalSelection)
  }
  const pixelSize = useVisiblePixelSize()

  return (
    <ChannelsSelection className="ChannelsEditableSelection" range={internalSelection}>
      <ChannelsSelectionHandle
        className="handle -start"
        position={internalSelection[0]}
        min={0}
        max={internalSelection[1] - pixelSize}
        setPosition={(position) =>
          position < internalSelection[1] && setInternalSelection([position, internalSelection[1]])
        }
        updateSelection={() => {
          if (autoplayEnabled) {
            play([internalSelection[0], internalSelection[0] + 1.5 * sampleRate])
          }

          updateSelection()
        }}
      />

      <ChannelsSelectionHandle
        className="handle -end"
        position={internalSelection[1]}
        min={internalSelection[0] + pixelSize}
        max={length}
        setPosition={(position) => {
          position > internalSelection[0] && setInternalSelection([internalSelection[0], position])
        }}
        updateSelection={() => {
          if (autoplayEnabled) {
            play([internalSelection[1] - 1.5 * sampleRate, internalSelection[1]])
          }

          updateSelection()
        }}
      />
    </ChannelsSelection>
  )
}
